
	import { defineComponent, Ref, ref } from 'vue';

	import ValidationAlert from '@/ChildrenComponents/ValidationAlert.vue';
	import SingleErrorMessage from '@/ChildrenComponents/Participant/Common/SingleErrorMessage.vue';

	import { MedicationForEdit } from '@/Models/IMedication';

	import { MedicationService } from '@/Services/medication-service';
	import { DateHelper } from '@/Services/Helper/date-helper';
	import { ValidationHelper } from '@/Services/Helper/validation-helper';

	export default defineComponent({
		name: "add-medication-dialog",
		components: { ValidationAlert, SingleErrorMessage },
		emits: ["close", "save"],
		props: { source: MedicationForEdit },
		setup(): { form: Ref } {
			const form = ref(null);
			return { form: form };
		},
		created() {
			if (this.source != undefined && this.source != null) {
				this.medication = this.source;
			}
		},
		data () {
			return {
				requiredRules: ValidationHelper.requiredRules,
				medication: {} as MedicationForEdit | null,
				buttonText: "Save Medication",
				isSaving: false,
				errorMessage: "",
				validationMessages: [] as string[],
			}
		},
		methods: {
			closeDialog(): void {
				this.$emit("close");
			},
			prepareForSave() {
				if (this.medication) {
					this.medication.startDate = DateHelper.standardizeDate(this.medication.startDateForEdit) ?? new Date();
					this.medication.endDate = DateHelper.standardizeDate(this.medication.endDateForEdit);
				}
			},
			async saveItem() {
				const { valid } = await this.form.validate();
				if (!valid || !this.medication) {
					this.isSaving = false;
					return;
				}

				this.prepareForSave();
				return MedicationService.save(this.medication).then(result => {
					this.validationMessages = result.messages;
					if (result.isValid && result.resultObject != null) {
						this.$emit("save", result.resultObject);
					}
				}).catch(error => this.errorMessage = error.message).finally(() => this.isSaving = false);
			},
		},
		watch: {
			source() {
				this.medication = this.source?.medicationId != undefined ? this.source : null;
				this.isSaving = false;
				this.buttonText = "Save Medication";
			},
		},
	});
